import { t } from 'i18next';

import { generalConfig } from '@sola/config/lib/getters.js';
import { MergeField, MergeFieldOptions } from '@sola/schema/lib/contentful.js';

// todo: are there reasonable global fallbacks to add here?
export const mergeFields = (
  string: string,
  mergeValues: MergeFieldOptions,
  fallbackValues?: MergeFieldOptions,
) => {
  if (!string || !mergeValues) {
    return string;
  }

  const allMergeValues: MergeFieldOptions = {
    ...mergeValues,
    CDSP_RATE: mergeValues.CDSP_RATE
      ? t('priority:mergeFallbacks.rate', {
          rate: mergeValues.CDSP_RATE,
        })
      : t('priority:mergeFallbacks.rate', {
          rate: generalConfig.rate,
        }),
  };

  let mergedString = string;

  Object.keys(allMergeValues).forEach((key) => {
    const mergeValue = allMergeValues[key as MergeField];
    const fallbackValue = fallbackValues?.[key as MergeField];

    if (mergeValue) {
      mergedString = mergedString.replaceAll(`{{${key}}}`, mergeValue);
    } else if (fallbackValue) {
      mergedString = mergedString.replaceAll(`{{${key}}}`, fallbackValue);
    } else {
      // last ditch effort to not expose merge field values
      mergedString = mergedString.replaceAll(`{{${key}}}`, '');
    }
  });

  return mergedString;
};
